import { CommonModule } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ModuleWithProviders, NgModule } from '@angular/core';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyRouterModule } from '../route.module';

import { HelpComponent } from './help.component';
import { HelpRoutes } from './help.route';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(HelpRoutes),
    ],
    declarations: [HelpComponent],
})
export class CmpsHelpModule {}
